// @flow
import * as Immutable from 'immutable';
import ImmutableModel from './ImmutableModel';

import { VehicleStatus } from './VehicleStatus';
import { LatLng } from './LatLng';
import { TaskChecklistValue } from './TaskPod';

import type { VehicleStatusModelType } from './VehicleStatus';
import type { LatLngModelType } from './LatLng';
import type { TaskChecklistValueModelType } from './TaskPod';

export type StatusUpdateModelType = {
    actor: string,
    drift: ?number,
    isFar: ?boolean,
    latlng: ?LatLngModelType,
    time: string,
    vehicleStatus: ?VehicleStatusModelType,
    checklistValues: Array<TaskChecklistValueModelType>
};

export type TaskStatusUpdateModelType = {
    accepted: ?StatusUpdateModelType,
    assigned: ?StatusUpdateModelType,
    cancelled: ?StatusUpdateModelType,
    completed: ?StatusUpdateModelType,
    started: ?StatusUpdateModelType,
    arrived: ?StatusUpdateModelType
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class StatusUpdate extends ImmutableModel {
    static fromJS(json: StatusUpdateModelType): StatusUpdate {
        const state: Object = Object.assign({}, json);
        state.latlng = state.latlng
            ? LatLng.fromJS(state.latlng)
            : state.latlng;
        state.vehicleStatus = state.vehicleStatus
            ? VehicleStatus.fromJS(state.vehicleStatus)
            : state.vehicleStatus;
        state.checklistValues = Immutable.List(
            state.checklistValues
        ).map(item => TaskChecklistValue.fromJS(item));
        return new this(Immutable.Map(state));
    }

    toJS(): StatusUpdateModelType {
        return {
            actor: this.actor,
            drift: this.drift,
            isFar: this.isFar,
            latlng: this.latlng ? this.latlng.toJS() : this.latlng,
            time: this.time,
            vehicleStatus: this.vehicleStatus
                ? this.vehicleStatus.toJS()
                : this.vehicleStatus,
            checklistValues: this.checklistValues
                .toArray()
                .map(item => item.toJS())
        };
    }

    get actor(): string {
        return this._state.get('actor');
    }

    setActor(actor: string): this {
        return this.clone(this._state.set('actor', actor));
    }

    get drift(): ?number {
        return this._state.get('drift');
    }

    setDrift(drift: ?number): this {
        return this.clone(this._state.set('drift', drift));
    }

    get isFar(): ?boolean {
        return this._state.get('isFar');
    }

    setIsFar(isFar: ?boolean): this {
        return this.clone(this._state.set('isFar', isFar));
    }

    get latlng(): ?LatLng {
        return this._state.get('latlng');
    }

    setLatlng(latlng: ?LatLng): this {
        return this.clone(this._state.set('latlng', latlng));
    }

    get time(): string {
        return this._state.get('time');
    }

    setTime(time: string): this {
        return this.clone(this._state.set('time', time));
    }

    get vehicleStatus(): ?VehicleStatus {
        return this._state.get('vehicleStatus');
    }

    setVehicleStatus(vehicleStatus: ?VehicleStatus): this {
        return this.clone(this._state.set('vehicleStatus', vehicleStatus));
    }

    get checklistValues(): Immutable.List<TaskChecklistValue> {
        return this._state.get('checklistValues');
    }

    setChecklistValues(
        checklistValues: Immutable.List<TaskChecklistValue>
    ): this {
        return this.clone(this._state.set('checklistValues', checklistValues));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class TaskStatusUpdate extends ImmutableModel {
    static fromJS(json: TaskStatusUpdateModelType): TaskStatusUpdate {
        const state: Object = Object.assign({}, json);
        state.accepted = state.accepted
            ? StatusUpdate.fromJS(state.accepted)
            : state.accepted;
        state.assigned = state.assigned
            ? StatusUpdate.fromJS(state.assigned)
            : state.assigned;
        state.cancelled = state.cancelled
            ? StatusUpdate.fromJS(state.cancelled)
            : state.cancelled;
        state.completed = state.completed
            ? StatusUpdate.fromJS(state.completed)
            : state.completed;
        state.started = state.started
            ? StatusUpdate.fromJS(state.started)
            : state.started;
        state.arrived = state.arrived
            ? StatusUpdate.fromJS(state.arrived)
            : state.arrived;
        return new this(Immutable.Map(state));
    }

    toJS(): TaskStatusUpdateModelType {
        return {
            accepted: this.accepted ? this.accepted.toJS() : this.accepted,
            assigned: this.assigned ? this.assigned.toJS() : this.assigned,
            cancelled: this.cancelled ? this.cancelled.toJS() : this.cancelled,
            completed: this.completed ? this.completed.toJS() : this.completed,
            started: this.started ? this.started.toJS() : this.started,
            arrived: this.arrived ? this.arrived.toJS() : this.arrived
        };
    }

    get accepted(): ?StatusUpdate {
        return this._state.get('accepted');
    }

    setAccepted(accepted: ?StatusUpdate): this {
        return this.clone(this._state.set('accepted', accepted));
    }

    get assigned(): ?StatusUpdate {
        return this._state.get('assigned');
    }

    setAssigned(assigned: ?StatusUpdate): this {
        return this.clone(this._state.set('assigned', assigned));
    }

    get cancelled(): ?StatusUpdate {
        return this._state.get('cancelled');
    }

    setCancelled(cancelled: ?StatusUpdate): this {
        return this.clone(this._state.set('cancelled', cancelled));
    }

    get completed(): ?StatusUpdate {
        return this._state.get('completed');
    }

    setCompleted(completed: ?StatusUpdate): this {
        return this.clone(this._state.set('completed', completed));
    }

    get started(): ?StatusUpdate {
        return this._state.get('started');
    }

    setStarted(started: ?StatusUpdate): this {
        return this.clone(this._state.set('started', started));
    }

    get arrived(): ?StatusUpdate {
        return this._state.get('arrived');
    }

    setArrived(arrived: ?StatusUpdate): this {
        return this.clone(this._state.set('arrived', arrived));
    }
}
